import { AutoSwitchActionTypes } from '@store/me'

export const autoSwitchError = (error: any) => ({
  type: AutoSwitchActionTypes.AUTOSWITCH_ERROR,
  payload: error,
})
